import { IconIdentifier } from '@aus-platform/design-system';
import { RoutesEnum } from 'shared/routes';
import { FeatureFlag, UserType } from '../../shared/enums';
import type { NavItemGroup } from '../components/accordion-sidenav/types';
import { NavGroupType, NavItemName } from './enums';

export const navItems: NavItemGroup[] = [
  // Reports + Dashboards Section.
  {
    itemType: NavGroupType.Dashboards,
    parentItem: {
      itemName: NavItemName.Reports,
      itemKeys: ['/reports'],
      route: RoutesEnum.Reports,
      iconIdentifier: IconIdentifier.FileCheck,
      enableForFeature: FeatureFlag.PowerBIReport,
    },
    groupIcon: IconIdentifier.Dashboard,
    defaultExpanded: true,
    children: [
      {
        itemName: NavItemName.Productivity,
        itemKeys: [`/${RoutesEnum.DashboardProductivity}`],
        route: `${RoutesEnum.Dashboard}/${RoutesEnum.DashboardProductivity}/${RoutesEnum.DashboardProductivityVolume}`,
        iconIdentifier: IconIdentifier.Productivity,
        enableForFeature: FeatureFlag.ProductivityDashboard,
      },
      {
        itemName: NavItemName.PlanVsActual,
        itemKeys: [`/${RoutesEnum.DashboardPlanVsActual}`],
        route: `${RoutesEnum.Dashboard}/${RoutesEnum.DashboardPlanVsActual}`,
        iconIdentifier: IconIdentifier.Balance,
      },
    ],
  },

  // Workspace Section.
  {
    itemType: NavGroupType.Workspace,
    children: [
      {
        itemName: NavItemName.Workspace,
        itemKeys: ['/3d-map'],
        route: RoutesEnum.Map3D,
        iconIdentifier: IconIdentifier.Map3D,
      },
      {
        itemName: NavItemName.Projects,
        itemKeys: ['/projects'],
        route: RoutesEnum.Projects,
        iconIdentifier: IconIdentifier.Site,
      },
      {
        itemName: NavItemName.SwipeMap2D,
        itemKeys: ['/swipe-map'],
        route: RoutesEnum.SwipeMap,
        iconIdentifier: IconIdentifier.SwipeMap,
      },
      {
        itemName: NavItemName.SwipeMap3D,
        itemKeys: ['/3d-swipe-map'],
        route: RoutesEnum.SwipeMap3D,
        iconIdentifier: IconIdentifier.SwipeMap,
        enableForFeature: FeatureFlag.SwipeMap3d,
      },
    ],
  },

  // Management Section.
  {
    itemType: NavGroupType.Management,
    children: [
      {
        itemName: NavItemName.AccessTags,
        itemKeys: ['/access-tags'],
        route: RoutesEnum.AccessTags,
        iconIdentifier: IconIdentifier.Tag,
      },
      {
        itemName: NavItemName.Users,
        itemKeys: ['/users'],
        route: RoutesEnum.Users,
        iconIdentifier: IconIdentifier.People,
      },
      {
        itemName: NavItemName.UserGroups,
        itemKeys: ['/user-groups'],
        route: RoutesEnum.UserGroups,
        iconIdentifier: IconIdentifier.UserGroup,
      },
    ],
  },

  // Processing Section.
  {
    itemType: NavGroupType.Processing,
    children: [
      {
        itemName: NavItemName.Processing,
        itemKeys: ['/processing'],
        route: RoutesEnum.Processing,
        iconIdentifier: IconIdentifier.Gears,
        enableForFeature: FeatureFlag.Processing,
      },
      {
        itemName: NavItemName.OrganisationSettings,
        itemKeys: ['/org-settings'],
        route: null,
        iconIdentifier: IconIdentifier.GearFill,
        enableForFeature: FeatureFlag.Processing,
        includeUserRole: [UserType.OrgAdmin],
      },
    ],
  },
];
